import useJSDWidget from "src/hooks/useJSDWidget";

const JSDWidget = () => {
  useJSDWidget();
  return null;
};

export default JSDWidget;
